import * as React from 'react';

import classname from 'classnames';
import { ISingleProductContainerData } from './single-product-container.data';
import { ISingleProductContainerProps } from './single-product-container.props.autogenerated';

/**
 *
 * SingleProductContainer component
 * @extends {React.Component<ISingleProductContainerProps<ISingleProductContainerData>>}
 */
class SingleProductContainer extends React.Component<ISingleProductContainerProps<ISingleProductContainerData>> {

    // ------------------------------------------------------
    // ------------------------------------------------------
    public render(): JSX.Element | null {
        if (!this.props.data.productAttributes.result) { return null; }

        const { slots } = this.props;
        const hasSlots = slots && slots.content && slots.content.length;
        return (
            <div className={classname('single-product-container', this.props.config.className)}>
                {hasSlots && slots.content}
            </div>
            );
    }
}

export default SingleProductContainer;